<template>
  <v-dialog
    width="600px"
    height="800px"
    :value="show"
    :persistent="true">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
        <h2 v-if="!confirm">
          Cambiar compañia
        </h2>
        <h2 v-else>
          <v-icon>fa fa-info-circle</v-icon> Desea cambiar de compañía?
        </h2>
      </v-card-title>
      <v-card-text class="pb-4">
        <template  v-if="!confirm">
          <template v-if="!hasCompanies">
            No tiene permisos para ver esto.
          </template>
          <template v-else-if="companies.length">
            <v-text-field
              solo
              label="Buscar.."
              color="grey"
              append-icon="fas fa-search"
              v-model="search"
              class="mb-3">
            </v-text-field>
            <div class="box">
              <vue-perfect-scrollbar class="scrollbar">
                <v-list>
                  <v-list-tile
                    class="list-company-item"
                    :class="{
                      'item-active': company.name === selectedCompany
                    }"
                    v-for="(company, index) in filteredCompanies"
                    :key="`company-items-${index}`"
                    @click="selectedCompany = company.name">
                    <v-list-tile-title>
                      {{ company.name }}
                    </v-list-tile-title>
                    <company-avatar :company-id="company.id"></company-avatar>
                  </v-list-tile>
                </v-list>
              </vue-perfect-scrollbar>
            </div>
          </template>
          <template v-else>
            No tiene companias.
          </template>
        </template>
        <template v-else>
          <template v-if="error">
            {{ error }}
          </template>
          <template v-else>
            Serás transferido a la compañía <strong>{{ selectedCompany }}</strong>
          </template>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <div>
          <v-btn flat color="black" @click="close">
            <template v-if="confirm">
              CANCELAR
            </template>
            <template v-else>
              CERRAR
            </template>
          </v-btn>
          <v-btn
            v-if="hasCompanies"
            flat
            class="k-orange-linear-text"
            :loading="loading"
            :disabled="!selectedCompany"
            @click="save">
            CAMBIAR COMPAÑÍA
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CompanyAvatar from '@/components/global/CompanyAvatar/CompanyAvatar';

export default {
  components: {
    CompanyAvatar,
    VuePerfectScrollbar,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: '',
      search: '',
      loading: false,
      searching: false,
      confirm: false,
      companies: [],
      selectedCompany: '',
    };
  },
  computed: {
    hasCompanies() {
      return this.$auth.user().total_companies > 0;
    },
    filteredCompanies() {
      const companies = this.companies.filter(item => item.id !== this.$auth.user().company_id);
      if (this.search) {
        return companies.filter((item) => item.name.toLowerCase().includes(this.search.toLowerCase()));
      }
      return companies;
    },
  },
  methods: {
    getCompanies() {
      if (this.hasCompanies) {
        this.axios.get('/users/companies').then(({ data }) => {
          this.companies = data;
        }).catch(() => {
          this.error = 'Error cargando compañias'
        });
      }
    },
    close() {
      if (this.confirm) {
        this.confirm = false;
      } else {
        this.$emit('close');
      }
    },
    save() {
      this.error = '';
      if (this.confirm) {
        if (this.selectedCompany) {
          this.loading = true;
          this.axios.post('users/change-company', {
            company: this.selectedCompany,
          }).then(({ data }) => {
            switch (data.message) {
              case 'NO_COMPANY_EMAIL':
                this.loading = false;
                this.error = 'Error cambiando de compañia';
                break;
              case 'TRANSFER_COMPANY':
                window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${data.new_token}`;
                this.$emit('change-company');
                break;
              default:
                this.loading = false;
                this.error = 'Ya esta conectado a esta compañia'
                break;
            }
          }).catch((error) => {
            this.loading = false;
            this.$emit('error', error.response.data.message || 'Error cambiando de empresa, comuniquese con soporte.')
            this.$emit('close');
          });
        }
      } else {
        this.confirm = true;
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.getCompanies();
      } else {
        this.error = '';
        this.search = '';
        this.confirm = false;
        this.companies = [];
        this.selectedCompany = '';
        this.loading = false;
        this.searching = false;
      }
    },
  },
};
</script>

<style scoped>
  .list-company-item {
    border: 1px solid transparent;
  }
  .list-company-item.item-active {
    border: 1px solid #FF8000;
  }
  .box {
    box-shadow: 0px 3px 10px #0000001C;
  }
  .scrollbar {
    height: 360px;
  }
</style>


// WEBPACK FOOTER //
// src/components/global/ChangeCompanyModal/ChangeCompanyModal.vue